import React from "react";
import { alpha, Box, Stack, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";

const SEVERITY_ICONS = {
  success: CheckCircleOutlineIcon,
  info: InfoOutlinedIcon,
  warning: WarningAmberOutlinedIcon,
  error: ErrorOutlineIcon,
};

export default function Note({
  title,
  children,
  error = false,
  severity,
  variant = "standard",
  action,
  sx = [],
  iconSx = [],
  ...props
}) {
  const tone = severity || (error ? "error" : undefined);
  const Icon = SEVERITY_ICONS[tone] || InfoOutlinedIcon;

  return (
    <Stack
      direction='row'
      spacing={1}
      alignItems={action ? "center" : "flex-start"}
      role={tone ? "alert" : undefined}
      {...props}
      sx={[
        { p: 2, bgcolor: "action.hover", borderRadius: 2 },
        tone &&
          ((theme) => ({
            ...theme.typography.body2,
            color:
              theme.palette[tone][
                theme.palette.mode === "dark" ? "light" : "dark"
              ],
            bgcolor: alpha(
              theme.palette[tone].main,
              theme.palette.mode === "dark" ? 0.16 : 0.08
            ),
          })),
        variant === "outlined" && {
          border: 1,
          borderColor: tone ? `${tone}.main` : "divider",
          bgcolor: "transparent",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Icon
        sx={[
          {
            fontSize: 18,
            color: tone ? `${tone}.main` : "text.secondary",
            mt: action ? 0 : 0.25,
            flexShrink: 0,
          },
          ...(Array.isArray(iconSx) ? iconSx : [iconSx]),
        ]}
      />
      <Box sx={{ minWidth: 0, flex: 1, overflowWrap: "anywhere" }}>
        {title && (
          <Typography variant='body2' fontWeight={600}>
            {title}
          </Typography>
        )}
        {children != null && <Box sx={{ mt: title ? 0.5 : 0 }}>{children}</Box>}
      </Box>
      {action && (
        <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
          {action}
        </Box>
      )}
    </Stack>
  );
}
